import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import focusable from '../../components/Focusable/Focusable'
import * as UI from '../../lib/ui'
import { LivePlayerError } from './LivePlayerError'

class LivePlayerMain extends React.PureComponent {
  handleBySpatialNavigation = true
  id = 'livestreamplayback'

  constructor(props) {
    super(props)
    this.state = {
      isExternalFocused: false,
    }
  }

  componentDidMount() {
    UI.registerFocusableComponent({ screen: this.id })
    UI.setFocusedComponent(this.id)
  }

  componentDidUpdate(prevProps) {
    const isFocusedComponentDifferent =
      this.props.ui.focusedComponent !== prevProps.ui.focusedComponent
    const focusedComponentMatchesLivePlayer =
      this.props.ui.focusedComponent === this.id
    if (isFocusedComponentDifferent && focusedComponentMatchesLivePlayer) {
      this.setState({
        isExternalFocused: true,
      })
      this.props.setFocus()
    }

    if (this.props.ui.focusedComponent === 'SidePanel') {
      this.setState({
        isExternalFocused: false,
      })
    }
  }

  onKeyEvent(key) {
    let handled = false
    if (key === 'BACK' || key === 'LEFT') {
      UI.setFocusToSidePanel()
      handled = true
    }
    return handled
  }

  render() {
    return <LivePlayerError isExternalFocused={this.state.isExternalFocused} />
  }
}

const mapStateToProps = (state) => {
  return {
    ui: state.ui,
  }
}

LivePlayerMain.propTypes = {
  setFocus: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
  ui: PropTypes.shape({
    focusedComponent: PropTypes.string,
    side_panel_opened: PropTypes.bool,
  }),
  hasFocus: PropTypes.bool,
}

export default connect(mapStateToProps, null, null)(focusable(LivePlayerMain))
